export enum LocalStoreName {
    ACTIVE_TASK = "ACTIVE_TASK",
    ACTIVE_TASK_TAGS = "ACTIVE_TASK_TAGS",
    ACTIVE_TASK_PROJECT = "ACTIVE_TASK_PROJECT",
}